<template>
    <div>
        <!-- 添加或修改 -->
        <el-dialog
            :title="
                isdialogType === 'edit'
                    ? '修改面授课时信息'
                    : isdialogType === 'add'
                    ? '添加面授课时信息'
                    : '面授课时信息'
            "
            :visible.sync="dialogFormVisible"
        >
            <el-form :model="form" label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="面授课时名称">
                            <el-input
                                v-model="form.courseName"
                                :disabled="isdialogType === 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="面授课时">
                            <el-input
                                v-model="form.tiem"
                                :disabled="isdialogType === 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="面授时间">
                            <el-input
                                v-model="form.openTime"
                                :disabled="isdialogType === 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="结束时间">
                            <el-input
                                v-model="form.endTime"
                                :disabled="isdialogType === 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="合作院校">
                            <el-input
                                :disabled="true"
                                v-model="form.schoolName"
                                v-if="isdialogType === 'check'"
                            ></el-input>
                            <el-select
                                v-else
                                v-model="form.schoolName"
                                placeholder="请选择报名方式"
                            >
                                <el-option
                                    v-for="item in schoolList"
                                    :key="item.id"
                                    :label="item.title"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="合作机构">
                            <el-input
                                :disabled="true"
                                v-model="form.companyName"
                                v-if="isdialogType === 'check'"
                            ></el-input>
                            <el-select
                                v-else
                                v-model="form.companyName"
                                placeholder="请选择报名方式"
                            >
                                <el-option
                                    v-for="item in companyList"
                                    :key="item.id"
                                    :label="item.title"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="任课老师">
                            <el-input
                                :disabled="true"
                                v-model="form.uname"
                                v-if="isdialogType === 'check'"
                            ></el-input>
                            <el-select
                                v-else
                                v-model="form.uname"
                                placeholder="请选择报名方式"
                                @visible-change="teacherName"
                            >
                                <el-option
                                    v-for="item in teacherList"
                                    :key="item.id"
                                    :label="item.uname"
                                    :value="item.uid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item label="面授班级">
                            <el-input
                                style="width: 80%"
                                type="textarea"
                                v-model="form.classCode"
                                autosize
                                :disabled="isdialogType === 'check'"
                            ></el-input>
                            <el-button
                                @click="chooseClass"
                                :disabled="isdialogType === 'check'"
                                >选择</el-button
                            >
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="面授地址">
                            <el-input
                                v-model="form.address"
                                :disabled="isdialogType === 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="开播说明">
                            <el-input
                                v-model="form.explain"
                                :disabled="isdialogType === 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="leftButtonFn">
                    {{ isdialogType === "check" ? "返回" : "保存修改" }}
                </el-button>
                <el-button type="primary" @click="rightButtonFn">
                    {{ isdialogType === "check" ? "修改" : "返回" }}
                </el-button>
            </div>

            <ChooseClass
                ref="chooseClass"
                :classType="1"
                @choseClasses="choseClasses"
                :courseId="course.id"
            />
        </el-dialog>
    </div>
</template>

<script>
import {
    getTeacherBySchool,
    saveOrUpdateTeacherCourse,
    getListByCategory,
} from "@/api/FaceToTeach/classTimeapi.js";
import ChooseClass from "./chooseClass.vue";
export default {
    components: {
        ChooseClass,
    },
    // 课程id，是否显示弹窗，弹窗类型（添加或修改或查看），课时管理id
    props: ["videoId", "dialogFormVisible", "dialogType", "course"],
    data() {
        return {
            // 查看弹窗信息
            form: {
                courseName: "",
                tiem: "",
                openTime: "",
                endTime: "",
                schoolName: "",
                companyName: "",
                uname: "",
                classCode: "",
                address: "",
                explain: "",
                batchId: "",
                albumIds: "",
            },
            // 是否查看
            isdialogType: "",
            // 机构列表
            companyList: [],
            // 学校列表
            schoolList: [],
            // 老师列表
            teacherList: [],
        };
    },
    methods: {
        // 修改，确定按钮
        async leftButtonFn() {
            if (this.isdialogType !== "check") {
                // 显示修改页面，保存按钮
                if (this.isdialogType === "edit") {
                    // 发起修改请求
                    await saveOrUpdateTeacherCourse({
                        id: this.course.id,
                        batchId: this.form.batchId,
                        albumIds: this.form.albumIds,
                        videoId: this.videoId,
                        openTime: this.form.openTime,
                        closeTime: this.form.endTime,
                        uids: this.form.uname,
                        name: this.form.courseName,
                        tiem: this.form.tiem,
                        explain: this.form.explain,
                        address: this.form.address,
                    });
                } else {
                    // 发起新增请求
                    await saveOrUpdateTeacherCourse({
                        batchId: this.form.batchId,
                        albumIds: this.form.albumIds,
                        videoId: this.videoId,
                        openTime: this.form.openTime,
                        closeTime: this.form.endTime,
                        uids: this.form.uname,
                        name: this.form.courseName,
                        tiem: this.form.tiem,
                        explain: this.form.explain,
                        address: this.form.address,
                    });
                }
                // 提示父组件更新
            }
            this.$emit("update:dialogFormVisible", false);
        },
        rightButtonFn() {
            if (this.isdialogType !== "check") {
                this.$emit("update:dialogFormVisible", false);
            } else {
                // 显示查看页面，修改按钮
                this.isdialogType = "edit";
            }
        },
        async init() {
            // 机构列表
            const company = await getListByCategory({ schoolCategory: 28 });
            this.companyList = company.data.data;
            // 学校列表
            const school = await getListByCategory({ schoolCategory: 27 });
            this.schoolList = school.data.data;
        },
        // 学校名称
        schoolNamebyId(id) {
            const res = this.schoolList.filter((item) => item.id === id);
            return res.title;
        },
        // 机构名称
        companyNamebyId(id) {
            const res = this.companyList.filter((item) => item.id === id);
            return res.title;
        },
        // 老师列表
        async teacherName(val) {
            if (val) {
                let teacher = await getTeacherBySchool({
                    schoolId: this.form.schoolName,
                    companyId: this.form.companyName,
                });
                this.teacherList = teacher.data.data || [];
            }
        },

        chooseClass() {
            this.$refs.chooseClass.dialogVisible = true;
        },
        choseClasses(msg) {
            let choseClass = "";
            msg.forEach((item) => {
                choseClass += item.batch + "\n";
            });
            this.form.classCode = choseClass;
            this.form.batchId = msg.map((item) => item.batchId).join();
            this.form.albumIds = msg.map((item) => item.albumId).join();
        },
    },
    created() {
        this.init();
    },

    watch: {
        dialogType: function () {
            this.isdialogType = this.dialogType;
        },
        course: function () {
            this.form = this.course;
        },
    },
};
</script>

<style>
</style>